
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/eden",
      function () {
        return require("private-next-pages/eden.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/eden"])
      });
    }
  